import { Button, Grid } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import DirectionsBikeTwoToneIcon from "@material-ui/icons/DirectionsBikeTwoTone";
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import BarChartTwoToneIcon from "@mui/icons-material/BarChartTwoTone";
import Avatar from "@mui/material/Avatar";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getBookingOverview } from "../../store/actions";
import "./dashboard.css";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: "100%",
      padding: "20px",
    },
    cardContent: {
      textAlign: "center",
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    text: { color: "black" },
  })
);


interface Props {
  getBookingOverview: any;
  bookingoverview: any;
  userDetails: any;
  loading: any
}

const Dashboard: React.FC<Props> = ({
  getBookingOverview,
  bookingoverview,

  loading,
}) => {
  const classes = useStyles();


  useEffect(() => {
    getBookingOverview("");
  }, []);
  // const assignedPhNum =
  //   bookingoverview?.phlebo_assigned + bookingoverview?.phlebo_unassigned;

  return (
    <div style={{ width: "90%", margin: "60px auto" }}>
      <Grid
        container
        spacing={1}
        direction="row"
        style={{ alignItems: "right", display: "flex" }}
      >
        <Grid item xs={8}>
          <h4 style={{ fontWeight: "bold" }}>GENOMICS RESEARCH ASSESSIONING DASHBOARD</h4>
        </Grid>
        <Grid item xs={2}>
          <Link
            to={`/dashboard/gnre/samaadhan_itrack`}
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              style={{ marginLeft: "1rem", marginBottom: "1rem", backgroundColor: "#0D4C92", color: "white" }}
            >
              Samaadhan Itrack
            </Button>
          </Link>
        </Grid>
        <Grid item xs={2}>
          <Link
            to={`/dashboard/gnre/browseData`}
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              style={{ marginLeft: "1rem", marginBottom: "1rem",backgroundColor:"#0f044f",color:"white" }}
            >
              Browse Data
            </Button>
          </Link>
        </Grid>
      </Grid>
      <div style={{ margin: "10px 0px 0px 0px" }} id="geno">
        <h6>Current Status </h6>
        <div className="cardsAppointment">
          <div>
            <Grid container>
              <Grid item sm={3}>
                <Avatar
                  sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                  aria-label="recipe"
                >
                  <BarChartTwoToneIcon style={{ color: "#fa4d83" }} />
                </Avatar>
              </Grid>
              <Grid item sm={9}>
                <h5 style={{ color: "#ffffff" }}>{bookingoverview?.totalReceivedSample}</h5>
                <span style={{ color: "#ffffff" }}>Total Received Samples</span>
                <br />
                <span style={{ color: "grey" }}>STAGE 1</span>
              </Grid>
            </Grid>
          </div>
          <div style={{ marginLeft: "2%" }}>
            <Grid container>
              <Grid item sm={3}>
                <Avatar
                  sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                  aria-label="recipe"
                >
                  <DirectionsBikeTwoToneIcon style={{ color: "#fa4d83" }} />
                </Avatar>
              </Grid>
              <Grid item sm={9}>
                <h5 style={{ color: "#ffffff" }}>{bookingoverview?.totalPassedSample}</h5>
                <span style={{ color: "#ffffff" }}>Total Pass Samples</span>
                <br />
                <span style={{ color: "grey" }}>STAGE 1</span>
              </Grid>
            </Grid>
          </div>
          <div style={{ marginLeft: "2%" }}>
            <Grid container>
              <Grid item sm={3}>
                <Avatar
                  sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                  aria-label="recipe"
                >
                  <DirectionsBikeTwoToneIcon style={{ color: "#fa4d83" }} />
                </Avatar>
              </Grid>
              <Grid item sm={9}>
                <h5 style={{ color: "#ffffff" }}>{bookingoverview?.projects}</h5>
                <span style={{ color: "#ffffff" }}>Project Created</span>
                <br />
                <span style={{ color: "grey" }}>STAGE 2</span>
              </Grid>
            </Grid>
          </div>
          <div style={{ marginLeft: "0%" }}>
            <Grid container>
              <Grid item sm={3}>
                <Avatar
                  sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                  aria-label="recipe"
                >
                  <AccessibilityIcon style={{ color: "#fa4d83" }} />
                </Avatar>
              </Grid>
              <Grid item sm={9}>
                <h5 style={{ color: "#ffffff" }}>{bookingoverview?.sampleQcCount}</h5>
                <span style={{ color: "#ffffff" }}>Sample Storage/QC</span>
                <br />
                <span style={{ color: "grey" }}>STAGE 3</span>
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <Grid item sm={3}>
                <Avatar
                  sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                  aria-label="recipe"
                >
                  <ContactPhoneOutlinedIcon style={{ color: "#fa4d83" }} />
                </Avatar>
              </Grid>
              <Grid item sm={9}>
                <h5 style={{ color: "#ffffff" }}>{bookingoverview?.totalLibraryCreated + bookingoverview?.totalLibraryOutsourced}</h5>
                <span style={{ color: "#ffffff" }}>Library</span>
                <br />
                <span style={{ color: "grey" }}>STAGE 4</span>
              </Grid>
            </Grid>
          </div>
          <div style={{ marginLeft: "2%" }}>
            <Grid container>
              <Grid item sm={3}>
                <Avatar
                  sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                  aria-label="recipe"
                >
                  <ContactPhoneOutlinedIcon style={{ color: "#fa4d83" }} />
                </Avatar>
              </Grid>
              <Grid item sm={9}>
                <h5 style={{ color: "#ffffff" }}>{bookingoverview?.totalLibraryOutsourced}</h5>
                <span style={{ color: "#ffffff" }}>Sequencing</span>
                <br />
                <span style={{ color: "grey" }}>STAGE 5</span>
              </Grid>
            </Grid>
          </div>
          <div style={{ marginLeft: "2%" }}>
            <Grid container>
              <Grid item sm={3}>
                <Avatar
                  sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                  aria-label="recipe"
                >
                  <ContactPhoneOutlinedIcon style={{ color: "#fa4d83" }} />
                </Avatar>
              </Grid>
              <Grid item sm={9}>
                <h5 style={{ color: "#ffffff" }}>{bookingoverview?.bioinfoCount}</h5>
                <span style={{ color: "#ffffff" }}> Projects in BioInformatics</span>
                <br />
                <span style={{ color: "grey" }}>STAGE 6</span>
              </Grid>
            </Grid>
          </div>
           <div>
            <Grid container>
              <Grid item sm={3}>
                <Avatar
                  sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                  aria-label="recipe"
                >
                  <ContactPhoneOutlinedIcon style={{ color: "#fa4d83" }} />
                </Avatar>
              </Grid>
              <Grid item sm={9}>
                <h5 style={{ color: "#ffffff" }}>{bookingoverview?.billingClosed}</h5>
                <span style={{ color: "#ffffff" }}>Closed Projects</span>
                <br />
                <span style={{ color: "grey" }}>STAGE 7</span>
              </Grid>
            </Grid>
          </div>

        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  bookingoverview: state.GenomicsLabReducer.bookingoverview,
  loading: state.GenomicsLabReducer.loading,
});

export default connect(mapStateToProps, {
  getBookingOverview,
})(Dashboard);
